/**
 * Tarjeta de KPI reutilizable para las páginas de Marketing.
 *
 * Pendiente: hoy MarketingWebSeo / Analytics / Ads / Estado declaran su propia
 * versión inline; en próximos refactors se irán migrando a este componente.
 */
export default function KpiCard({ label, value, icon: Icon, hint, delta = null }) {
  return (
    <div className="bg-white border rounded-lg p-4">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs uppercase tracking-wide font-semibold text-gray-500">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-gray-400" />}
      </div>
      <div className="text-2xl font-bold text-gray-900">{value}</div>
      <div className="flex items-center gap-2 mt-1">
        {delta != null && (
          <span
            className={`text-xs font-medium ${
              delta > 0 ? 'text-emerald-600' : delta < 0 ? 'text-red-600' : 'text-gray-500'
            }`}
            title="vs. periodo anterior"
          >
            {delta > 0 ? '▲' : delta < 0 ? '▼' : '·'} {Math.abs(delta * 100).toFixed(1)}%
          </span>
        )}
        {hint && <span className="text-xs text-gray-500">{hint}</span>}
      </div>
    </div>
  );
}

// Helpers de formato reutilizables , es-ES.
export const fmtNum = (n) => (n ?? 0).toLocaleString('es-ES');
export const fmtPct = (v) => (v == null ? '—' : `${(v * 100).toFixed(2)}%`);
export const fmtPos = (v) => (v == null || v === 0 ? '—' : v.toFixed(1));
export const fmtFecha = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
};
